import styled from "styled-components";
import { CaretDownMenuIcon } from "~components/Icons";

export const Wrapper = styled.div`
  margin-bottom: 24px;
  color: ${({ theme }) => theme.palette.grey[0]};
`;

export const Brand = styled.div`
  display: flex;
  position: relative;
`;

export const Title = styled.h1`
  font-weight: 500;
  margin: 0 13px 0 0;
  font-size: 32px;
  line-height: 48px;
`;

export const Dropdown = styled.div<{ $isOpened: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  display: ${({ $isOpened }) => ($isOpened ? "block" : "none")};
  z-index: 12;
  background-color: ${({ theme }) => theme.palette.grey[700]};
  color: ${({ theme }) => theme.palette.grey[0]};
  width: 204px;
  border-radius: 8px;
  padding: 20px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
`;

export const DropdownTitle = styled.p`
  font-size: 10px;
  line-height: 16px;
`;

export const StreamLabel = styled.p<{ $isSelected: boolean }>`
  color: ${({ $isSelected }) => ($isSelected ? "#00AB55" : "inherit")};
  cursor: pointer;
  font-size: 16px;
  font-weight: ${({ $isSelected }) => ($isSelected ? "bold" : "inherit")};
  line-height: 24px;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: #00ab55;
    font-weight: bold;
  }
`;
export const StreamNameContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
`;

export const StreamName = styled.p`
  margin: 0;
  width: 204px;
  height: 36px;
  border-radius: 100px;
  padding: 16px 20px;
  background: #333333;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  text-transform: uppercase;
`;

export const Icon = styled(CaretDownMenuIcon)`
  flex-shrink: 0;
  margin-left: auto;
`;
